import { Groups, TreeNode } from '@elementary/common-ui/types';

const buildPathsFromReportGroups = (reportGroups: Groups): string[] => {
  if (!reportGroups || !reportGroups?.data) return [];
  const { data } = reportGroups;
  const paths: string[] = [];

  const buildPaths = (group: TreeNode, currentPath: string) => {
    if (!currentPath) paths.push(...Object.keys(group));
    Object.keys(group).forEach((key) => {
      if (key === '__files__') {
        paths.push(currentPath);
      } else {
        buildPaths(
          group[key] as unknown as TreeNode,
          currentPath ? `${currentPath}/${key}` : key,
        );
      }
    });
  };

  buildPaths(data as unknown as TreeNode, '');

  return paths;
};

export default buildPathsFromReportGroups;
